import React, { useEffect } from 'react';
import personalDataProces from '../constants/insideInfo/personalDataProcessing';
import PAGE_TITLES from '../constants/pageTitles';
import '../styles/user_agreement.scss';
import { useScrollTop } from '../helpers/useScrollTop';

export const UserData = () => {
  useScrollTop();
  useEffect(() => {
    document.title = PAGE_TITLES.aboutUS;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const elemNavigate = document.querySelector('.forhead');
    if (elemNavigate) elemNavigate.style.display = 'block';
  }, []);

  const buildUl = mass =>
    mass.map(item => {
      const nestedList = item.points ? buildUl(item.points) : null;
      let { text } = item;
      if (item.links) {
        text = item.text.map((txt, index) =>
          item.links.includes(index) ? (
            <a href={/@/.test(txt) ? `mailto:${txt}` : txt} key={index}>
              {' '}
              {txt}{' '}
            </a>
          ) : (
            txt
          )
        );
      }
      return (
        <li key={item.id}>
          {text}
          <ul>{nestedList}</ul>
        </li>
      );
    });

  return (
    <div className="user-data">
      <h2 className="title">{personalDataProces.title}</h2>
      {personalDataProces.points.map(item => {
        const nestedList = buildUl(item.points);
        return (
          <section key={item.id}>
            <h3 className="title-item">{item.title}</h3>
            {item.additionally ? <p>{item.additionally}</p> : null}
            <ol>{nestedList}</ol>
          </section>
        );
      })}
    </div>
  );
};
